import { _post } from "../../Api";
import articlesStore from "./ArticlesStore";
import { setModifierarticles, setModifiergroups, setTranslations } from "./ArticlesActions";
import { toast } from "react-toastify";
import { CreateModifierarticle, Modifierarticle } from "./models/Modifierarticle";
import { Modifiergroup } from "./models/Modifiergroup";
import convertToJson from "../../helper/convertToJson";

export function createModifierarticles(merchantId, modifierarticles) {
  const articlesJSON = modifierarticles.map((modifierarticle) => convertToJson(modifierarticle));

  _post("/nova/v2/merchant/" + merchantId + "/modifierarticles", articlesJSON)
    .catch((err) =>
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      })
    )
    .then((res) => {
      let newModifierarticles = { ...articlesStore.modifierarticles };
      let newModifiergroups = { ...articlesStore.modifiergroups };
      res.data.forEach((modifierarticle) => {
        let modifiergroupIds = modifierarticle.m_modifiergroups.map((modifiergroup) => modifiergroup.id);

        let newModifierarticle = CreateModifierarticle(modifierarticle, modifiergroupIds);
        newModifierarticles[newModifierarticle.id] = newModifierarticle;

        modifiergroupIds.forEach((modifiergroupId) => {
          const newModifiergroup = Object.assign(new Modifiergroup(), newModifiergroups[modifiergroupId]);
          newModifiergroup.modifierarticleIds.push(newModifierarticle.id);
          newModifiergroups[modifiergroupId] = newModifiergroup;
        });
      });
      setModifierarticles(newModifierarticles);
      setModifiergroups(newModifiergroups);
      toast.success("Saved", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    });
}

export function updateModifierarticles(merchantId, modifierarticles, newData, oldValues) {
  let data = [];
  for (let i in modifierarticles) {
    data.push({
      modifierarticleId: modifierarticles[i].id,
      ...newData[i],
    });
  }
  return _post("/nova/v2/merchant/" + merchantId + "/modifierarticles", data)
    .catch((e) => {
      let newModifierarticles = { ...articlesStore.modifierarticles };
      modifierarticles.forEach((modifierarticle, i) => {
        newModifierarticles[modifierarticle.id].updated_at = new Date().toLocaleString();
      });
      setModifierarticles(newModifierarticles);
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.log(e);
      return Promise.reject();
    })
    .then((res) => {
      let newModifierarticles = { ...articlesStore.modifierarticles };
      let newModifiergroups = { ...articlesStore.modifiergroups };

      res.data.map((modifierarticle) => {
        let modifiergroupIds = modifierarticle.m_modifiergroups.map((modifiergroup) => modifiergroup.id);

        let newModifierarticle = CreateModifierarticle(modifierarticle, modifiergroupIds);
        newModifierarticles[newModifierarticle.id] = newModifierarticle;

        modifiergroupIds.forEach((modifiergroupId) => {
          if (!newModifiergroups[modifiergroupId].modifierarticleIds.includes(newModifierarticle.id)) {
            const newModifiergroup = Object.assign(new Modifiergroup(), newModifiergroups[modifiergroupId]);
            newModifiergroup.modifierarticleIds.push(newModifierarticle.id);
            newModifiergroups[modifiergroupId] = newModifiergroup;
          }
        });
      });
      setModifiergroups(newModifiergroups);
      setModifierarticles(newModifierarticles);
      toast.success("Saved", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    });
}

export function updateModifierarticlesTranslations(
  merchantId,
  modifierarticles: [Modifierarticle],
  newData,
  oldValues
) {
  let data = [];
  for (let i in modifierarticles) {
    data.push({
      modifierarticleId: modifierarticles[i].id,
      ...newData[i],
    });
  }
  return _post("/nova/v2/merchant/" + merchantId + "/modifierarticles", data)
    .catch((e) => {
      toast.error("Something went wrong.", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      console.log(e);
      return Promise.reject();
    })
    .then((res) => {
      let newTranslations = { ...articlesStore.translations };
      let newModifierarticles = { ...articlesStore.modifierarticles };

      res.data.map((modifierarticle) => {
        const newTranslation = modifierarticle.translation;
        newTranslations[newTranslation.id] = newTranslation;

        if (newModifierarticles[modifierarticle.id].translation_id !== newTranslation.id) {
          let newModifierarticle = CreateModifierarticle(
            modifierarticle,
            modifierarticle.m_modifiergroups.map((modifiergroup) => modifiergroup.id)
          );
          newModifierarticles[newModifierarticle.id] = newModifierarticle;
        }
      });
      setTranslations(newTranslations);
      setModifierarticles(newModifierarticles);
      toast.success("Saved", {
        position: "bottom-right",
        autoClose: 2000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    });
}
